import React, { useEffect, useState } from "react"
import Dropdown from "react-bootstrap/Dropdown"
import { SlDrawer, SlIcon, SlTooltip, SlSwitch } from "@shoelace-style/shoelace/dist/react"
import copySvg from "../../assets/images/copy.svg"
import { Toast } from "../../shared/Toast"
import ellipsisSvg from "../../assets/images/ellipsis.svg"
import Select from "react-select"
import API from "../../services/api"
import DatePicker from "react-datepicker"
import { getMidnightTimestamp, InteractionType } from "../../utils/constants"
import NoDataFound from "../../shared/NoDataFound"
import "react-datepicker/src/stylesheets/datepicker.scss"
import "react-datepicker/dist/react-datepicker.min.css"
import { CSVLink } from "react-csv"
import { formatDateDDMMYYY } from "../../utils/dateFormat"
import { useSelector } from "react-redux"
import uncheckSvg from "../../assets/images/uncheck.svg"
import Interaction from "./Interaction"
// Add custom styles for React Select
function InteractionHistory(props) {
  const salesUsersList = useSelector((state) => state.Head.subordinates)
  const [selectedMonth, setSelectedMonth] = useState(new Date())
  const [interactionHistory, setInteractionHistory] = useState([])
  const [data, setData] = useState({})
  const [selectedBrand, setSelectedBrand] = useState(props.brand.brand_id)
  // const [selectedSrc, setSelectedSrc] = useState("all");
  const [showCampaignInfo, setShowCampaignInfo] = useState(0)
  const [campaignInfo, setCampaignInfo] = useState([])
  const [loader, setLoader] = useState(false)
  const [newsPaperData, setNewsPaperData] = useState([])
  const [selectedInteraction, setSelectedInteraction] = useState("0")
  const [editData, setEditdata] = useState()
  const [showInteraction, setShowInteraction] = useState(false)
  const [brand, setBrand] = useState({
    brand_id: "",
    brand_name: "",
  })

  const brandOptions = [
    { value: -1, label: "All" },
    ...props.brandOptions
];

  const interactionOptions = [
    { value: "-1", label: "All" },
    { value: "0", label: "All" },
    { value: "1", label: "Direct Meeting" },
    { value: "2", label: "Virtual Meeting" },
    { value: "3", label: "Call" },
    { value: "4", label: "Whatsapp" },
    { value: "5", label: "Email" },
  ]
  const handleMonthChange = (date) => {
    setSelectedMonth(date)
  }
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault()
    }
  }
  const handleClickhdl = async (phnnum) => {
    if (phnnum) {
      await navigator.clipboard.writeText(phnnum)
      Toast("success", "Number Copied")
    }
  }

  const handleTag = async (id, tag) => {
    try {
      const res = await API({
        url: "/accountManagement/tag",
        method: "POST",
        data: {
          interaction_id: id,
          untag: tag === "untag" ? true : undefined,
        },
      })
      if (res.status === "SUCCESS") {
        Toast("success", `Interaction ${tag === "untag" ? "untagged" : "tagged"} successfully`)
        fetchInteractionHistory()
      }else Toast("error",res.data.message)
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    const fetchCampaignInfo = async () => {
      setLoader(true)
      try {
        const reqObj = { brand_id: selectedBrand, month: selectedMonth, sales_person_id: props.sale }
        const res = await API({
          url: "/user/campaign_creation/getCampaignInfo",
          method: "POST",
          responseType: "json",
          data: reqObj,
        })
        if (res.code === 200) {
          setCampaignInfo(res.data)
        } else if (res.code === 404) {
          setCampaignInfo([])
          Toast("error", "No campaign info found or page not found")
        }
      } catch (error) {
        console.error(error)
        setCampaignInfo([])
        Toast("error", "Error fetching campaign info. Please try again.")
      } finally {
        setLoader(false)
      }
    }
    fetchCampaignInfo()
  }, [selectedMonth, selectedBrand])
  function calculateDaysAgo(date, days = null) {
    // Convert the input date to milliseconds
    date = date * 1000
    const inputDate = new Date(date).getTime()
    // Get today's date in milliseconds
    const today = new Date().getTime()

    // Calculate the difference in milliseconds
    const difference = today - inputDate

    // Convert the difference to days
    const daysDifference = Math.floor(difference / (1000 * 60 * 60 * 24))
    if (days !== null) {
      return daysDifference
    }

    if (daysDifference < 30) {
      return `${daysDifference} day${daysDifference !== 1 ? "s" : ""} ago`
    } else {
      const monthsDifference = Math.floor(daysDifference / 30)
      return `${monthsDifference} month${monthsDifference !== 1 ? "s" : ""} ago`
    }
  }
  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      ref={ref}
      style={{ color: "gray" }}
      onClick={(e) => {
        e.preventDefault()
        onClick(e)
      }}
    >
      {children}
    </a>
  ))
  const CustomMenu = React.forwardRef(({ children, style, className, "aria-labelledby": labeledBy }, ref) => {
    return (
      <div
        ref={ref}
        style={{
          inset: "inherit",
          position: "absolute",
          right: 0,
          transform: "translate(0px, 2px)",
        }}
        className={`${className} px-4 py-4  drop-shadow-sm`}
        aria-labelledby={labeledBy}
      >
        <p className="text-[10px] my-0 mb-2 font-semibold">Office</p>
        <div className="d-flex gap-4 items-center mb-2">
          <div className="d-flex gap-2 items-center">
            <SlIcon library="lucide" name="phone" className="text-[10px] text-green-500"></SlIcon>
            <a className="mobNum text-xs" href={`tel:${data.mobile}`}>
              {data.mobile}
            </a>
          </div>
          <img
            src={copySvg || "/placeholder.svg"}
            alt="copy"
            className="hover:cursor-pointer w-3"
            onClick={() => handleClickhdl(data.mobile)}
          ></img>
        </div>
        <div className="d-flex gap-4  items-center mb-2">
          <div className="d-flex gap-2 items-center">
            <SlIcon library="lucide" name="mail" className="text-[10px] text-gray-500"></SlIcon>
            <span className="text-xs">{data.email}</span>
          </div>
          <img
            src={copySvg || "/placeholder.svg"}
            alt="copy"
            className="hover:cursor-pointer w-3"
            onClick={() => handleClickhdl(data.email)}
          ></img>
        </div>
      </div>
    )
  })

  const fetchInteractionHistory = async () => {
    setLoader(true)
    try {
      const reqObj = {
        brand_id: selectedBrand,
        // src: selectedSrc,
        month: selectedMonth,
        type: selectedInteraction,
        sales_person_id: props.sales === -1 ? undefined : props.sales,
      }
      if (props.brand.sales_person_id) {
        reqObj.sales_person_id = props.brand.sales_person_id
      }
      const res = await API({
        url: "/accountManagement/getInteractionHistory",
        method: "POST",
        responseType: "json",
        data: reqObj,
      })
      if (res.code === 200) {
        setInteractionHistory(res.data)
      } else if (res.code === 404) {
        setInteractionHistory([])
        Toast("error", "No data found or page not found")
      }
    } catch (error) {
      console.error(error)
      setInteractionHistory([])
      Toast("error", "Error fetching interaction history. Please try again.")
    } finally {
      setLoader(false)
    }
  }
  const fetchNewsPapers = async () => {
    try {
      const res = await API({
        url: "/market/newspapers",
        method: "POST",
        responseType: "json",
        data: {},
      })
      if (res.code === 200) {
        setNewsPaperData([...res.data])
      }
    } catch (error) {
      console.error(error)
    }
  }

  const getLogo = (target) => {
    return newsPaperData.filter((item) => item.name === target)[0]?.logo
  }

  useEffect(() => {
    fetchNewsPapers()
  }, [])

  const downLoadData = interactionHistory?.map((row) => ({
    ...row,
    email1: row.email1 !== null ? row.email1 : "",
    email2: row.email2 !== null ? row.email2 : "",
    last_active_date: row.last_active_date !== null ? formatDateDDMMYYY(row.last_active_date) : "",
    mobile1: row.mobile1 !== null ? row.mobile1 : 0,
    mobile2: row.mobile2 !== null ? row.mobile2 : 0,
    target_platform: Array.isArray(row.target_platform) ? row.target_platform.join(", ") : "",
    type: InteractionType[row.type],
    interacted_date: formatDateDDMMYYY(row.interacted_date),
  }))
  const headers = [
    { label: "Name", key: "name" },
    { label: "Designation", key: "designation" },
    { label: "Description", key: "description" },
    { label: "Email 1", key: "email1" },
    { label: "Email 2", key: "email2" },
    { label: "Mobile 1", key: "mobile1" },
    { label: "Mobile 2", key: "mobile2" },
    { label: "Head Name", key: "head_name" },
    { label: "Interacted Date", key: "interacted_date" },
    { label: "Last Active Date", key: "last_active_date" },
    { label: "Target Platform", key: "target_platform" },
    { label: "Type", key: "type" },
  ]

  useEffect(() => {
    fetchInteractionHistory()
  }, [selectedBrand, selectedMonth, selectedInteraction])

  return (
    <div>
      <SlDrawer
        open={props.show}
        onSlRequestClose={handleRequestClose}
        noHeader={true}
        // contained={true}
        className="intrDrawer"
        style={{ "--size": "100vw" }}
      >
        <div>
          <div className="mb-2">
            <SlIcon
              library="lucide"
              className="text-xl cursor-pointer"
              name="arrow-left"
              onClick={() => props.setShow(false)}
            ></SlIcon>
          </div>
          <div className="d-flex justify-between flex-wrap">
            <div>
              <h3 className="whitespace-nowrap">{!showCampaignInfo ? "Interaction History" : "Campaign Info"}</h3>
            </div>
            <div className="d-flex gap-3 items-center">
              {/* <SlSelect
                placeholder="Select Brand"
                value={selectedSrc}
                label="Source"
                onSlChange={(e) => setSelectedSrc(e.target.value)}
              >
                <SlOption value="all">All</SlOption>
               {newsPaperData.map((item)=>{
                return <SlOption key={item.name} value={item.name}>{item.name}</SlOption>
               })}
              </SlSelect> */}
              <SlSwitch checked={showCampaignInfo} onSlChange={() => setShowCampaignInfo(!showCampaignInfo)}>
                Show Campaign Info
              </SlSwitch>
              <div>
                <label className="form-label">Brands</label>
                <Select
                            placeholder="Select Brand"
                            value={brandOptions.find(option => option.value === selectedBrand) || null}
                            options={brandOptions}
                            onChange={(selectedOption) => setSelectedBrand(selectedOption.value)}
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    minWidth: "200px",
                                }),
                            }}
                        />
              </div>
              <div>
                <label className="form-label">Select Month</label>
                <DatePicker
                  showMonthYearPicker
                  className="form-control"
                  selected={selectedMonth}
                  onChange={handleMonthChange}
                  dateFormat="MM/yyyy"
                />
              </div>
              {!showCampaignInfo && (
                <>
                  <div>
                    <label className="form-label">Interaction</label>
                    <Select
                      value={interactionOptions.find((option) => option.value === selectedInteraction)}
                      onChange={(selectedOption) => setSelectedInteraction(selectedOption.value)}
                      options={interactionOptions}
                      className="basic-select"
                      classNamePrefix="select"
                    />
                  </div>
                  <CSVLink
                    title="Download"
                    data={downLoadData}
                    headers={headers}
                    filename={`interaction_${selectedBrand.label}.csv`}
                    className="btn btn-primary"
                  >
                    <span className="text-white"> &#8615;</span>
                  </CSVLink>
                </>
              )}
            </div>
          </div>
          {showCampaignInfo && !loader && campaignInfo.length > 0 ? (
            <div className="flex gap-3 flex-wrap">
              {campaignInfo.map((campaign, ind) => (
                <div className="rounded-lg border shadow-lg p-4 flex flex-col gap-2 bg-white max-w-xs" key={ind}>
                  <div className="flex flex-col font-semibold text-gray-700 items-start justify-center gap-2">
                    <div className="flex gap-2 text-xl bg-slate-300 rounded-md shadow-lg flex-wrap p-2">
                      <span className="">Brand : </span>
                      <span>{campaign.brand_name}</span>
                    </div>
                    <div className="flex gap-2 text-lg">
                      <SlIcon slot="prefix" name="user" library="lucide" />
                      <span>{campaign.sales_person_name}</span>
                    </div>
                  </div>
                  <div className="d-flex justify-between items-center">
                    <div className="font-semibold">
                      <span className="text-sm text-gray-700">Campaign Expected : </span>
                      <span>{formatDateDDMMYYY(campaign.campaign_date)}</span>
                    </div>
                    <div className="font-semibold">
                      <span className="text-sm text-gray-700">Info Given : </span>
                      <span>{formatDateDDMMYYY(campaign.reg_date)}</span>
                    </div>
                  </div>
                  <div className="d-flex gap-3 items-center">
                    <div className="font-semibold text-gray-700">
                      <span className="text-sm">Target Platforms : </span>
                      <div className="flex gap-2">
                        {campaign.target_platform?.map((target) => {
                          return (
                            <img
                              src={getLogo(target) || "/placeholder.svg"}
                              alt="logo"
                              style={{ maxWidth: "50px", height: "auto" }}
                            />
                          )
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : showCampaignInfo && campaignInfo?.length === 0 && !loader ? (
            <NoDataFound colspan="4" />
          ) : (
            <></>
          )}

          <div className="d-flex gap-2 mt-3 flex-wrap interactionHistory">
            {!showCampaignInfo && interactionHistory.length > 0 && !loader ? (
              interactionHistory.map((interaction, index) => {
                const expired = (Math.floor(Date.now()/1000) > getMidnightTimestamp(interaction.interacted_date,2)) ;
                return (
                  <div
                    className="rounded-lg border-[1px] p-[18px] d-flex flex-col gap-3 historyCard relative"
                    key={index}
                  >
                    <div className="d-flex justify-between items-center">
                      <div className="d-flex gap-2">
                        <div className="w-auto h-fit py-1.5 px-3  rounded-full d-flex justify-center bg-gray-300 items-center">
                          {interaction.name[0]}
                        </div>
                        <div>
                          <p className="my-0">{interaction.name}</p>
                          <p className="text-[#969696] text-xs my-0">{interaction.designation}</p>
                        </div>
                        {Math.round(Date.now() / 1000) - interaction.interacted_date <= 3600 &&
                        new Date(interaction.interacted_date * 1000).toDateString() === new Date().toDateString() ? (
                          <SlIcon
                            library="lucide"
                            name="pencil"
                            title="Edit Interaction"
                            className="cursor-pointer hover:text-sky-300"
                            onClick={() => {
                              setEditdata(interaction)
                              setBrand({ brand_id: interaction.brand_id, brand_name: interaction.brand_name })
                              setShowInteraction(true)
                            }}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                      <Dropdown className="mt-6">
                        <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                          <img
                            onClick={() => {
                              setData({
                                mobile: interaction.mobile1 || interaction.mobile2,
                                email: interaction.email1 || interaction.email2,
                              })
                            }}
                            src={ellipsisSvg || "/placeholder.svg"}
                            alt="icon"
                          />
                        </Dropdown.Toggle>
                        <Dropdown.Menu as={CustomMenu}></Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <p className="my-0 mb-2">{interaction.description}</p>
                    <div className="d-flex gap-3 items-center ">
                      <div className="font-semibold">
                        <span>{formatDateDDMMYYY(interaction.interacted_date)}</span>
                      </div>
                      <div className="d-flex gap-1 items-center font-semibold green-interaction">
                        <SlIcon library="lucide" name="clock-7" className="font-bold" />{" "}
                        <span>{calculateDaysAgo(interaction.interacted_date)}</span>
                      </div>
                      <div className="d-flex gap-2">
                        {interaction.target_platform?.map((target) => {
                          return <img src={getLogo(target) || "/placeholder.svg"} alt="logo"></img>
                        })}
                      </div>
                    </div>
                    <div className="border-b-[1px] mb-2"></div>
                    <div className="d-flex gap-2 flex-grow">
                      <p
                        className={`my-0 ${
                          interaction.type === 1
                            ? "met"
                            : interaction.type === 2
                              ? "virtual"
                              : interaction.type === 3
                                ? "called"
                                : interaction.type === 4
                                  ? "whatsapp"
                                  : "email"
                        }`}
                      >
                        {InteractionType[interaction.type]}
                      </p>
                    </div>
                    <div className="d-flex gap-2 items-center absolute top-1 right-2">
                      {salesUsersList?.length > 1 ? (
                        expired ? <span className="px-1 py-1 text-xs rounded-lg bg-red-200 text-center" title="You Can Only Tag/Untag Within 24 hours of Interaction">Tag expired </span>: 
                        <span className="px-1 py-1/2 text-white font-semibold rounded-md bg-sky-400 hover:bg-sky-500 cursor-pointer">
                          {interaction.head_name ? (
                            <span title={interaction?.head_name} className="d-flex gap-1 items-center">
                              Tagged
                              <sl-tooltip content="Untag this conversation">
                                <img
                                  onClick={() => handleTag(interaction.id, "untag")}
                                  src={uncheckSvg || "/placeholder.svg"}
                                  alt="x"
                                />
                              </sl-tooltip>
                            </span>
                          ) : (
                            <span onClick={() => handleTag(interaction.id, "tag")}>Tag</span>
                          )}
                        </span>
                      ) : (
                        ""
                      )}
                      {salesUsersList?.length === 1 && interaction.head_name ? (
                        <span
                          title={interaction?.head_name}
                          className="px-2 py-1 text-white font-semibold rounded-md bg-sky-400"
                        >
                          Tagged{" "}
                        </span>
                      ) : (
                        ""
                      )}
                      {interaction.is_agency === 1 && (
                        <span>
                          <SlTooltip content={"Agency"}>
                            <SlIcon library="lucide" className=" w-5 h-5 text-green-600 " name="star"></SlIcon>
                          </SlTooltip>
                        </span>
                      )}
                    </div>
                  </div>
                )
              })
            ) : !showCampaignInfo && !interactionHistory?.length && !loader ? (
              <NoDataFound colspan="4" />
            ) : (
              <></>
            )}
          </div>
        </div>
      </SlDrawer>
      {showInteraction && (
        <Interaction
          edit={true}
          editData={editData}
          show={showInteraction}
          setShow={setShowInteraction}
          brand={brand}
          loadData={fetchInteractionHistory}
        />
      )}
    </div>
  )
}

export default InteractionHistory

